import { ErrorMessage, Field } from "formik";
import { Col, FormGroup, Label, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFormikContext } from "formik";

const TitleAndClientSection = () => {
  return (
    <>
      <Row>
        <Col>
          <FormGroup>
            <Label check>SEO Title</Label>
            <Field
              name="seoTitle"
              type="text"
              className="form-control"
              placeholder="title"
            />
            <ErrorMessage
              name="seoTitle"
              component="span"
              className="text-danger"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label check>SEO Description</Label>
            <Field
              name="seoDescription"
              type="text"
              className="form-control"
              placeholder="SEO Description"
            />
            <ErrorMessage
              name="seoDescription"
              component="span"
              className="text-danger"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label check>Image Alt Text</Label>
            <Field
              name="seoImageAlt"
              type="text"
              className="form-control"
              placeholder="Image ALT"
            />
            <ErrorMessage
              name="seoImageAlt"
              component="span"
              className="text-danger"
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};

export default TitleAndClientSection;
